import axios from 'axios';

/**
   * Liste des actions
 */
export const Actions = {
    FETCH_DEPOTS_GESTION_REQUEST: 'FETCH_DEPOTS_GESTION_REQUEST',
    FETCH_DEPOTS_GESTION_SUCCESS: 'FETCH_DEPOTS_GESTION_SUCCESS',
    FETCH_DEPOTS_GESTION_FAILURE: 'FETCH_DEPOTS_GESTION_FAILURE'

};


/**
 * FETCH_DEPOTS_GESTION
 * ActionCreator pour la récupération des depotsGestion
 */
const fetchDepotsGestionRequest = () => ({ type: Actions.FETCH_DEPOTS_GESTION_REQUEST });
const fetchDepotsGestionSuccess = items => ({ type: Actions.FETCH_DEPOTS_GESTION_SUCCESS, items });
const fetchDepotsGestionFailure = error => ({ type: Actions.FETCH_DEPOTS_GESTION_FAILURE, error });



export const fetchDepotsGestion = () => (dispatch, getState) => {
    
    if (getState().depotGestion.depotsGestion.isLoading) {
        return;
    }
    if (getState().depotGestion.depotsGestion.items.length > 0) {
        return;
    }
    return dispatch(_fetchDepotsGestion());
};


const _fetchDepotsGestion = () => async (dispatch) => {
    
    dispatch(fetchDepotsGestionRequest());

    try {
        let response = await axios.get('api/depots-gestion');

        dispatch(fetchDepotsGestionSuccess(response.data));
    } catch (error) {
        console.error('fetchDepotsGestion : ', error);
        dispatch(fetchDepotsGestionFailure(error));
    }

};

